module.exports = __webpack_public_path__ + "img/p2-30.8b9db3ca.png";